import { StyleSheet, View } from 'react-native';

import {
	RadioGroup as RadioGroupLib,
	RadioGroupProps as RadioGroupLibProps,
} from '@ui-kitten/components';
import { Text } from '../Text';
import { fontFamilyRegular } from '../../theme';

export interface RadioGroupProps extends RadioGroupLibProps {
	label?: string;
}

export const RadioGroup = ({ label, ...props }: RadioGroupProps) => {
	return (
		<View>
			{label ? <Text style={styles.label}>{label}</Text> : null}
			<RadioGroupLib {...props} />
		</View>
	);
};

const styles = StyleSheet.create({
	label: {
		fontFamily: fontFamilyRegular,
		fontSize: 14,
		fontWeight: '500',
	},
});
